<template>
 <div class="RecommendationDetailsCard">
  <el-row>
   <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-for="(reco_data, index) in recommendationsList" :key="index" v-if="isDesktopExpertView">
    <el-card
     class="box-card"
     v-loading="reco_data.is_loading"
     :style="[
      index != 0
       ? {}
       : reco_data.risk_tag == 'low_risk'
       ? { boxShadow: '7px 0px 0px -1px #0BA042' } // box-shadow for low_risk
       : reco_data.risk_tag == 'moderate_risk'
       ? { boxShadow: '7px 0px 0px -1px #FFB800' } // box-shadow for moderate_risk
       : reco_data.risk_tag == 'high_risk'
       ? { boxShadow: '7px 0px 0px -1px #EA2526' } // Box-shadow for high_risk
       : { boxShadow: '7px 0px 0px -1px #FFB800' }, // Default box-shadow for moderate_risk
     ]"
    >
     <div v-loading="reco_data.is_strategy_loading" style="position: relative">
      <div
       :style="[
        index != 0
         ? {
            cursor: 'pointer',
            pointerEvents: 'none',
            minHeight: '300px',
           }
         : 'pointer',
       ]"
      >
       <div class="flex-space-between border-bottom-gray">
        <div style="width: 60%">
         <div class="flex flex-space-between" style="width: 100%">
          <div>
           <span class="stock-title cursor-pointer">{{ reco_data.stock.name }}</span>
           <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg" style="width: 15px; top: 4px; left: 2px" alt @click="loadTradingViewWidget(reco_data.stock.symbol)" />
           &nbsp;
          </div>
         </div>

         <div class="top-margin-5">
          <el-row>
           <el-col :xs="24" :sm="24" :md="24" :lg="13" :xl="13" class="margin-right-20">
            <span v-if="reco_data.stock.current_price">
             <span class="estimate-value right-margin-10" title="Current price">₹ {{ reco_data.stock.current_price }}</span>

             <span class="top-margin-10 stock-section-inc" :style="[reco_data.stock.price_difference >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
              <span style="font-size: 18px" v-if="reco_data.stock.price_difference >= 0">&#9652;</span>
              <span style="font-size: 18px" v-else>&#9662;</span>
              {{ reco_data.stock.price_difference }} ({{ reco_data.stock.potential_difference }}%)
             </span>
            </span>
            <span class="estimate-value right-margin-10" title="Current price" v-else>NA</span>
            <span>
             <img
              class="info-Logo cursor-pointer"
              src="../assets/images/Fundamental analysis.svg"
              alt
              @click="
               selectedSymbol = reco_data.stock.symbol;
               showSentimentCard = true;
              "
             />

             <el-popover placement="bottom" trigger="click" width="300" style="margin-bottom: 4px">
              <img class="info-Logo cursor-pointer" src="../assets/images/Logic.svg" alt slot="reference" />
              <div style="margin: 0">
               <div v-if="reco_data.category_stamp.length">
                <div class="input-label-xs-bold-black">Discovery Category</div>

                <div class="flex flex-wrap top-margin-15">
                 <div class="font-08rem" style="margin-right: 10px; margin-bottom: 15px" v-for="(stamp, tag_index) in reco_data.category_stamp" :key="tag_index">
                  <span class="stamp-category">
                   {{ stamp }}
                  </span>
                 </div>
                </div>
                <div class="bottom-line" style="border-bottom: 1px solid #e7e7e7; margin: 5px 0 15px"></div>
               </div>

               <div v-for="(item, item_index) in reco_data.report" :key="item_index">
                <div
                 v-for="(attachment, attachment_index) in item.files"
                 :key="attachment_index"
                 :style="[
                  attachment_index < item.files.length
                   ? {
                      borderBottom: '1px solid #ddd',
                      paddingBottom: '5px',
                      marginBottom: '15px',
                     }
                   : {},
                 ]"
                >
                 <div class="flex-space-between bottom-margin-5">
                  <div class="input-label-xs-bold-black" style="font-size: 0.7rem">
                   Attachment
                   {{ attachment_index + 1 }}
                  </div>

                  <div class="font-08rem primary-theme-color cursor-pointer" @click="downloadAttachment(attachment)">
                   <i class="el-icon-download"></i>
                   Download
                  </div>
                 </div>
                </div>
               </div>

               <div>
                <div class="input-label-xs-bold-black">Discovery Logic</div>
                <div class="input-label-gray font-08rem" style="max-height: 150px; overflow-y: auto; margin: 5px 0 10px" v-if="reco_data.logic_description">
                 {{ reco_data.logic_description }}
                </div>
                <div class="flex flex-wrap top-margin-15">
                 <div class="font-08rem" style="margin-right: 10px; margin-bottom: 15px" v-for="(subTags, tag_index) in reco_data.logic_tags" :key="tag_index">
                  <span class="sub-tags">
                   {{ subTags }}
                  </span>
                 </div>
                </div>
               </div>
              </div>
             </el-popover>
            </span>

            <div class="input-label-gray" style="font-size: 10px" v-if="reco_data.stock.current_datetime">
             {{ reco_data.stock.current_datetime | stock_live_price_date_filter }}
            </div>
           </el-col>

           <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" class="top-margin-10 flex">
            <el-tag size="mini" class="right-margin-10 sector-tag" effect="plain" title="Market size" type="info" v-if="reco_data.stock.market_cap">
             {{ reco_data.stock.market_cap }}
            </el-tag>

            <el-tag size="mini" class="right-margin-10 sector-tag" effect="plain" title="Sector" type="info" v-if="reco_data.stock.sector">
             {{ reco_data.stock.sector }}
            </el-tag>
           </el-col>
          </el-row>
         </div>
        </div>
        <div class="reco-date-mobile bottom-margin-10 top-margin-10 text-right" style="width: 40%">
         <label class="input-label-gray flex-end" style="font-size: 11px">
          Reco Date :
          {{ reco_data.created_at | stock_live_price_date_filter }}
          <span v-if="$router.currentRoute.path != '/past-recommendations'" style="position: relative; top: 1px"></span>
         </label>

         <div class="flex-end top-margin-5">
          <span class="font-08rem right-margin-5 font-weight-600 input-label-gray">{{ reco_data.duration == 'Long_term' ? 'Long Term' : reco_data.duration }}</span>

          <span
           class="secondary-theme-color text-right font-09rem cursor-pointer"
           style="margin-right: 5px"
           v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'YET TO LIVE') && $router.currentRoute.path == '/past-recommendations'"
           @click="
            openUpdateRecoDialog({
             reco_data: reco_data,
             index: index,
            })
           "
          >
           <i class="el-icon-edit"></i>
          </span>

          <span class="download-btn right-margin-5" style="text-align: right" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED') && $router.currentRoute.path == '/past-recommendations'" @click="exitReco(reco_data, index)">EXIT</span>
         </div>

         <div
          v-if="reco_data.risk_tag && reco_data.risk_tag.length"
          class="tags"
          :style="[
           reco_data.risk_tag == 'low_risk'
            ? { backgroundColor: '#ECFFF3', color: '#0BA042' } // text color for low_risk
            : reco_data.risk_tag == 'moderate_risk'
            ? { backgroundColor: '#FFF6E6', color: '#EDB21A' } // text color for moderate_risk
            : reco_data.risk_tag == 'high_risk'
            ? { backgroundColor: '#FFF1F1', color: '#EA2526' } // Text color for high_risk
            : { backgroundColor: '#FFF6E6', color: '#EDB21A' }, // Default text color for moderate_risk
           { textTransform: 'capitalize' }, // Capitalize the text
          ]"
         >
          {{ reco_data.risk_tag.replace(/_/g, ' ') }}
         </div>
        </div>
       </div>

       <el-row class="top-margin-15 reco-details">
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="border-right: 1px solid #ddd; height: 112px">
         <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
           <div class="flex-space-between profile-antestimateSection bottom-margin-10">
            <div class="flex" style="align-items: unset">
             <img v-if="!reco_data.user.pic || reco_data.filtered_by == 'company'" src="../assets/images/navBar/avatar.jpg" class="user-profile-pic" alt />

             <img v-else :src="serverHostName + reco_data.user.pic" class="user-profile-pic" alt />

             <div class="company-employee-details">
              <div class="label-lg-black-bold right-margin-3" :style="[$router.currentRoute.path == '/experts-past-recommendations' ? { cursor: 'pointer' } : { cursor: 'text' }]" style="text-transform: capitalize; font-size: 14px">
               <span v-if="reco_data.filtered_by == 'company'">{{ reco_data.user.company.name }}</span>
               <span v-else>{{ reco_data.user.full_name }}</span>
               <el-tooltip v-if="reco_data.user.mark_as_verified_user" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
                <img class="info-Logo cursor-pointer" src="../assets/images/verify.svg" style="width: 16px" alt />
               </el-tooltip>
              </div>

              <span v-if="reco_data.filtered_by == 'company'">
               <span class="right-margin-3 input-label-gray">{{ reco_data.user.full_name }} -</span>
               <span class="right-margin-3 input-label-gray">{{ reco_data.user.profession }}</span>
              </span>

              <span v-if="reco_data.filtered_by != 'company'">
               <span class="right-margin-3 input-label-gray" v-if="reco_data.user.company && reco_data.user.profession != 'Student'">{{ reco_data.user.company.name }} -</span>

               <span class="right-margin-3 input-label-gray" v-if="reco_data.user.profession == 'Student' && reco_data.user.institute_name">{{ reco_data.user.institute_name }} -</span>

               <span class="right-margin-3 input-label-gray">{{ reco_data.user.profession }}</span>
              </span>

              <img v-if="reco_data.source == 'marketplace'" src="../assets/images/loudspeaker1.svg" width="17" height="17" title="Public recommendation" style="vertical-align: middle; margin-left: 5px" />

              <br />

              <span class="right-margin-3 input-label-gray">
               Total Recommendation -
               <span class="input-label-bold-gray">
                {{ reco_data.user.total_reco ? reco_data.user.total_reco : 0 }}
               </span>
              </span>
              <br />
             </div>
            </div>
           </div>
          </el-col>
         </el-row>
         <div class="faded-border-bottom target-period-section-border">&nbsp;</div>
        </el-col>

        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
         <el-row class="performance-accuracy-container">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
           <div class="performance-section">
            <el-tooltip class="item" effect="dark" :disabled="reco_data.reco_status == 'YET TO LIVE'" :content="reco_data.reco_status == 'TARGET ACHIEVED' ? 100 + '%' : reco_data.performance + '%'" placement="top">
             <NewCircleProgress :transitionDuration="5000" :radius="44" :strokeWidth="10" :strokeColor="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0 ? '#079e3e' : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? '#d60918' : '#079e3e'" :value="getPerformanceWheelValue(reco_data) > 100 ? 100 : getPerformanceWheelValue(reco_data)">
              <div class style="font-size: 0.6rem">
               {{ reco_data.reco_status }}
              </div>
              <template v-slot:footer></template>
             </NewCircleProgress>
            </el-tooltip>

            <div class="progress-description">
             <div class="input-label-bold-gray">
              <span v-if="reco_data.reco_status == 'CLOSED'">
               As on
               {{ reco_data.closed_date_time | formatDate }}
              </span>

              <span v-if="reco_data.reco_status == 'TARGET ACHIEVED'">
               As on
               {{ reco_data.target_achieved_date_time | formatDate }}
              </span>

              <span v-if="reco_data.reco_status == 'TARGET NOT ACHIEVED'">
               As on
               {{ reco_data.target_not_achieved_date_time | formatDate }}
              </span>

              <span v-if="reco_data.reco_status == 'STOP LOSS TRIGGERED'">
               As on
               {{ reco_data.stop_loss_triggered_date_time | formatDate }}
              </span>

              <span v-if="reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'UPDATED'">As on {{ reco_data.stock.today | formatDate }}</span>

              <div class="input-label-bold-gray top-margin-5" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED') && reco_data.difference_in_days == 0">(Today)</div>

              <div class="input-label-bold-gray top-margin-5" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days != 0">
               ({{ reco_data.difference_in_days }}
               <span v-if="reco_data.difference_in_days > 1">Days</span>
               <span v-else>Day</span>
               from reco date)
              </div>

              <div class="input-label-bold-gray top-margin-5" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days == 0">(Updated Today)</div>

              <div class="input-label-bold-gray top-margin-5" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days != 0">
               ({{ reco_data.difference_in_days }}
               <span v-if="reco_data.difference_in_days > 1">Days</span>
               <span v-else>Day</span>
               from updated reco date)
              </div>

              <div class="input-label-bold-gray top-margin-5" v-if="(reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days == 0">(On Reco date)</div>

              <div class="input-label-bold-gray top-margin-5" v-if="reco_data.has_close_reco && reco_data.difference_in_days == 0 && reco_data.reco_status == 'TARGET ACHIEVED'">(On Updated Reco date)</div>

              <div class="progress-bar-legends-section top-margin-20" style="flex-direction: column">
               <div class="flex">
                <div class="progress-bar-legends" :style="[(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0 ? { 'background-color': '#079e3e' } : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? { 'background-color': '#d60918' } : reco_data.reco_status == 'TARGET ACHIEVED' ? { 'background-color': '#079e3e' } : { 'background-color': '#a29eab' }]">&nbsp;</div>
                <div class="legends-text input-label-xs-bold-black">Performance</div>
               </div>
               <div class="flex top-margin-5">
                <div class="progress-bar-legends">&nbsp;</div>
                <div class="legends-text input-label-xs-bold-black">Potential</div>
               </div>
              </div>
             </div>
            </div>
           </div>
          </el-col>
         </el-row>
        </el-col>

        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
         <div class="left-margin-20">
          <div class="remaining-potential remaining-potential-desktop roi-card-main">
           <div class="roi-card">
            <div class="input-label-bold-gray" style="margin: 0">Remaining Target</div>
            <div class="label-md-bold-black top-margin-5" style="color: #079e3e">
             <span style="margin-left: 5px">
              <span v-if="reco_data.reco_status == 'YET TO LIVE'">{{ reco_data.max_profit_in_percentage }}%</span>
              <span v-else-if="reco_data.reco_status == 'TARGET ACHIEVED'">0%</span>

              <span v-else>{{ !reco_data.potential_as_of_current_date ? 0 : reco_data.potential_as_of_current_date }}%</span>
             </span>
            </div>
           </div>
          </div>

          <div class="flex left-margin-5 top-margin-20">
           <el-button class="cursor-pointer period-type-tag" style="width: 47%; margin-left: 10px" :class="[reco_data.reco == 'Buy' ? 'active-period-type-tag' : reco_data.reco == 'Sell' ? 'active-period-type-tag-red' : reco_data.reco == 'Hold' ? 'active-period-type-tag-yellow' : 'period-type-tag']" v-on:click="goToTradePage(reco_data)">
            <img style="width: 14px; margin-right: 6px; position: relative; top: 3px" src="../assets/images/two-arrows.png" alt="" />
            {{ reco_data.reco }}
           </el-button>
          </div>
         </div>
        </el-col>
       </el-row>
       <div class="disclaimer-card" style="float: right">
        <div class="input-label-bold-gray">
         <el-popover placement="bottom" title="Disclaimer" width="200" trigger="click" content="Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.">
          <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg" style="height: 12px; top: 1px" alt slot="reference" />
         </el-popover>
         Disclaimer
        </div>
       </div>
       <div class="flex flex-center">
        <span class="input-label-gray cursor-pointer" style="color: red; margin: 10px 0px" icon @click="toggleMoreInfo(index)" v-if="reco_data.toggle_more_info">
         Less details
         <i class="el-icon-arrow-up"></i>
        </span>

        <span class="input-label-gray cursor-pointer" style="color: red; margin: 10px 0px; text-transform: capitalize" icon @click="toggleMoreInfo(index)" v-else>
         {{ reco_data.user.first_name ? reco_data.user.first_name + "'s" : reco_data.user.full_name ? reco_data.user.full_name.split(' ')[0] + "'s" : '' }}
         reco details
         <i class="el-icon-arrow-down"></i>
        </span>
       </div>

       <div class="faded-border-bottom">&nbsp;</div>

       <el-row :gutter="20" class="top-margin-20" v-if="reco_data.toggle_more_info">
        <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">&nbsp;</el-col>

        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" style="border: 1px solid #d9d9d9; padding: 20px; border-radius: 20px">
         <StockProgress :stockData="reco_data" :selectedIndex="index" :segment="'Equity'"></StockProgress>
        </el-col>
       </el-row>

       <div class="top-margin-20" v-if="reco_data.toggle_more_info && reco_data.closed_reco_list && reco_data.closed_reco_list.length" v-loading="reco_data.closed_reco_list_loading">
        <div class="faded-border-bottom">&nbsp;</div>

        <div class="label-md-bold-black top-margin-10">Previous recommendations</div>
        <div v-for="(item, itemIndex) in reco_data.closed_reco_list" :key="itemIndex">
         <el-row :gutter="20" class="top-margin-20">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
           <div style="margin: 2px 0" v-if="itemIndex == reco_data.closed_reco_list.length - 1">
            <div class="label-xs-bold" style="font-size: 12px">
             Original reco date :
             {{ item.created_at | close_reco_date_filter }}
            </div>
           </div>

           <div style="margin: 2px 0" v-if="itemIndex < reco_data.closed_reco_list.length - 1">
            <div class="label-xs-bold" style="font-size: 12px">
             Updated on :
             {{ item.closed_date_time | close_reco_date_filter }}
            </div>
           </div>

           <div class="reco-more-details-container isDeskTopView" style="border-right: 8px solid #d60918">
            <div class="vertical-flex">
             <label class="input-label-gray">RECO</label>
             <span class="label-xs-bold uppercase" :style="[item.reco == 'Buy' ? { color: '#079e3e' } : item.reco == 'Sell' ? { color: '#d60918' } : { color: '#e2ba00' }]">{{ item.reco }}</span>
            </div>

            <div>
             <div>
              <label class="input-label-gray">Reco Date</label>
              <div class="label-xs-bold">
               {{ item.created_at | formatDate }}
              </div>
             </div>

             <div class="top-margin-10">
              <label class="input-label-gray">Reco Price</label>
              <div class="label-xs-bold">₹ {{ item.reco_open_price }}</div>
             </div>
            </div>

            <div class="vertical-flex">
             <label class="input-label-gray">Performance</label>
             <span class="label-lg-bold" :style="[item.reco_status == 'CLOSED' && item.performance > 0 ? { color: '#079e3e' } : item.reco_status == 'CLOSED' && item.performance < 0 ? { color: '#d60918' } : { color: '#a29eab' }]">{{ !item.performance ? 0 : item.performance }}%</span>
            </div>

            <div>
             <div>
              <label class="input-label-gray">Last Tracked Date</label>
              <div class="label-xs-bold">
               {{ item.closed_date_time | formatDate }}
              </div>
             </div>
             <div class="top-margin-10">
              <label class="input-label-gray">Last Tracked Price</label>
              <div class="label-xs-bold">
               ₹
               {{ item.reco_status == 'CLOSED' ? item.closed_price : item.reco_status == 'TARGET ACHIEVED' ? item.target_achieved_price : item.reco_status == 'TARGET NOT ACHIEVED' ? item.target_not_achieved_price : item.reco_status == 'STOP LOSS TRIGGERED' ? item.stop_loss_triggered_price : item.stock.current_price }}
              </div>
             </div>
            </div>

            <div class="vertical-flex">
             <label class="input-label-gray">Potential</label>
             <div class="label-lg-bold" style="color: #979797">{{ !item.potential_as_of_current_date ? 0 : item.potential_as_of_current_date }}%</div>
            </div>

            <div>
             <div>
              <label class="input-label-gray">Target Period</label>
              <div class="label-xs-bold">
               {{ item.target_period }}
              </div>
             </div>
             <div class="top-margin-10">
              <label class="input-label-gray">Target Price</label>
              <div class="label-xs-bold">
               ₹ {{ item.target_price }}
               <span class="input-label-gray" style="font-size: 11px">({{ item.target_potential }}%)</span>
              </div>
             </div>
            </div>

            <div class="vertical-flex">
             <label class="input-label-gray">STATUS</label>
             <div class="label-xs-bold" style="color: #d60918">CLOSED</div>
            </div>
           </div>

           <div class="isMobileView" style="margin-top: 0px; padding: 8px; border: 1px solid #ddd; border-radius: 18px; border-right: 6px solid #d60918">
            <div class="flex-center">
             <label class="input-label-gray">RECO -</label>
             &nbsp;
             <span class="label-xs-bold uppercase" :style="[item.reco == 'Buy' ? { color: '#079e3e' } : item.reco == 'Sell' ? { color: '#d60918' } : { color: '#e2ba00' }]">{{ item.reco }}</span>
            </div>

            <div style="display: flex; justify-content: space-around" class="top-margin-10">
             <div class="col1" style="display: flex">
              <div class="row1">
               <div v-if="itemIndex == 0">
                <label class="input-label-gray">Reco Date</label>
                <div class="label-xs-bold">
                 {{ item.created_at | formatDate }}
                </div>
               </div>

               <div v-if="itemIndex > 0">
                <label class="input-label-gray">Reco Date</label>
                <div class="label-xs-bold">
                 {{ item.closed_date_time | formatDate }}
                </div>
               </div>

               <div>
                <label class="input-label-gray">Last Tracked Date</label>
                <div class="bottom-margin-10 label-xs-bold">
                 {{ item.closed_date_time | formatDate }}
                </div>
               </div>

               <div>
                <label class="input-label-gray">Target Period</label>
                <div class="bottom-margin-10 label-xs-bold">
                 {{ item.target_period }}
                </div>
               </div>
              </div>
             </div>

             <div class="col2">
              <div class="row2">
               <div>
                <label class="input-label-gray">Reco Price</label>
                <div class="bottom-margin-10 label-xs-bold">₹ {{ item.reco_open_price }}</div>
               </div>

               <div>
                <label class="input-label-gray">Last Tracked Price</label>
                <div class="bottom-margin-10 label-xs-bold">
                 ₹
                 {{ item.reco_status == 'CLOSED' ? item.closed_price : item.reco_status == 'TARGET ACHIEVED' ? item.target_achieved_price : item.reco_status == 'TARGET NOT ACHIEVED' ? item.target_not_achieved_price : item.reco_status == 'STOP LOSS TRIGGERED' ? item.stop_loss_triggered_price : item.stock.current_price }}
                </div>
               </div>

               <div>
                <label class="input-label-gray">Target Price</label>
                <div class="bottom-margin-10 label-xs-bold">
                 ₹ {{ item.target_price }}
                 <span class="input-label-gray" style="font-size: 11px">({{ item.target_potential }}%)</span>
                </div>
               </div>
              </div>
             </div>

             <div class="col3 vertical-flex">
              <label class="input-label-gray">Performance</label>
              <div class="label-lg-bold" :style="[item.reco_status == 'CLOSED' || (item.reco_status == 'EXIT' && item.performance > 0) ? { color: '#079e3e' } : (item.reco_status == 'CLOSED' || item.reco_status == 'EXIT') && item.performance < 0 ? { color: '#d60918' } : { color: '#a29eab' }]">{{ !item.performance ? 0 : item.performance }}%</div>

              <label class="input-label-gray">Potential</label>
              <div class="label-lg-bold" style="color: #979797">{{ !item.potential_as_of_current_date ? 0 : item.potential_as_of_current_date }}%</div>

              <label class="input-label-gray">STATUS</label>
              <div class="label-xs-bold" style="color: #d60918">CLOSED</div>
             </div>
            </div>
           </div>
          </el-col>
         </el-row>

         <div class="relative" v-if="itemIndex < reco_data.closed_reco_list.length - 1">
          <img src="../assets/images/company/arrow.svg" class="vl" />
         </div>
        </div>
       </div>

       <div v-if="reco_data.compared_experts_list && reco_data.compared_experts_list.length">
        <ComparedRecommendationsOfExpert :expertsRecommendationsList="reco_data.compared_experts_list" :parentIndex="index" :recoType="recoType"></ComparedRecommendationsOfExpert>
       </div>
      </div>
      <PremiumLock v-if="index != 0"></PremiumLock>
     </div>
    </el-card>
   </el-col>

   <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-for="(reco_data, index) in recommendationsList" :key="index" v-if="!isDesktopExpertView">
    <el-card
     class="box-card box-card-two"
     v-loading="reco_data.is_loading"
     :style="[
      index != 0
       ? {}
       : reco_data.risk_tag == 'low_risk'
       ? { boxShadow: '7px 0px 0px -1px #0BA042' } // box-shadow for low_risk
       : reco_data.risk_tag == 'moderate_risk'
       ? { boxShadow: '7px 0px 0px -1px #FFB800' } // box-shadow for moderate_risk
       : reco_data.risk_tag == 'high_risk'
       ? { boxShadow: '7px 0px 0px -1px #EA2526' } // Box-shadow for high_risk
       : { boxShadow: '7px 0px 0px -1px #FFB800' }, // Default box-shadow for moderate_risk
     ]"
    >
     <div v-loading="reco_data.is_strategy_loading" style="position: relative">
      <div
       :style="[
        index != 0
         ? {
            cursor: 'pointer',
            pointerEvents: 'none',
            minHeight: '450px',
           }
         : 'pointer',
       ]"
      >
       <div class="inner-card">
        <div class="reco-date-mobile text-right">
         <label class="input-label-gray flex-end" style="font-size: 11px">
          Reco Date :
          {{ reco_data.created_at | stock_live_price_date_filter }}
          <span v-if="$router.currentRoute.path != '/past-recommendations'" style="position: relative; top: 1px; left: 4px"></span>
         </label>

         <div class="flex-end">
          <span class="font-07rem right-margin-5 font-weight-600 input-label-gray">{{ reco_data.duration == 'Long_term' ? 'Long Term' : reco_data.duration }}</span>

          <!-- </div>
                  <div> -->
          <span
           class="secondary-theme-color text-right font-09rem cursor-pointer"
           style="margin-right: 5px"
           v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'YET TO LIVE') && $router.currentRoute.path == '/past-recommendations'"
           @click="
            openUpdateRecoDialog({
             reco_data: reco_data,
             index: index,
            })
           "
          >
           <i class="el-icon-edit"></i>
          </span>

          <span class="download-btn right-margin-5" style="text-align: right" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED') && $router.currentRoute.path == '/past-recommendations'" @click="exitReco(reco_data, index)">EXIT</span>
         </div>

         <div
          v-if="reco_data.risk_tag && reco_data.risk_tag.length"
          class="tags"
          :style="[
           reco_data.risk_tag == 'low_risk'
            ? { backgroundColor: '#ECFFF3', color: '#0BA042' } // text color for low_risk
            : reco_data.risk_tag == 'moderate_risk'
            ? { backgroundColor: '#FFF6E6', color: '#EDB21A' } // text color for moderate_risk
            : reco_data.risk_tag == 'high_risk'
            ? { backgroundColor: '#FFF1F1', color: '#EA2526' } // Text color for high_risk
            : { backgroundColor: '#FFF6E6', color: '#EDB21A' }, // Default text color for moderate_risk
           { textTransform: 'capitalize' }, // Capitalize the text
          ]"
         >
          {{ reco_data.risk_tag.replace(/_/g, ' ') }}
         </div>
        </div>
        <div class="first-sec">
         <div class="">
          <span class="stock-title cursor-pointer" style="font-size: 16px">
           {{ reco_data.stock.name }}
          </span>
          <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg" style="width: 14px; top: 4px; left: 2px" alt @click="loadTradingViewWidget(reco_data.stock.symbol)" />
          &nbsp;
          <div class="second-sec" style="margin-top: 0">
           <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
             <span v-if="reco_data.stock.current_price">
              <span class="estimate-value right-margin-10" title="Current price">₹ {{ reco_data.stock.current_price }}</span>

              <span class="stock-section-inc" :style="[reco_data.stock.price_difference >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
               <span style="font-size: 18px" v-if="reco_data.stock.price_difference >= 0">&#9652;</span>
               <span style="font-size: 18px" v-else>&#9662;</span>
               {{ reco_data.stock.price_difference }} ({{ reco_data.stock.potential_difference }}%)
              </span>
             </span>
             <span class="estimate-value right-margin-10" title="Current price" v-else>NA</span>

             <div class="flex flex-wrap" style="margin-top: -4px">
              <div class="input-label-gray" style="font-size: 11px" v-if="reco_data.stock.current_datetime">
               {{ reco_data.stock.current_datetime | stock_live_price_date_filter }}

               <span>
                <img class="info-Logo cursor-pointer" src="../assets/images/Fundamental analysis.svg" alt @click="openPopupForMoreDetails(reco_data)" />

                <el-popover placement="bottom" trigger="click" width="300" style="margin-bottom: 4px">
                 <img class="info-Logo cursor-pointer" src="../assets/images/Logic.svg" alt slot="reference" />
                 <div style="margin: 0">
                  <div v-if="reco_data.category_stamp.length">
                   <div class="input-label-xs-bold-black">Discovery Category</div>

                   <div class="flex flex-wrap top-margin-15">
                    <div class="font-08rem" style="margin-right: 10px; margin-bottom: 15px" v-for="(stamp, tag_index) in reco_data.category_stamp" :key="tag_index">
                     <span class="stamp-category">
                      {{ stamp }}
                     </span>
                    </div>
                   </div>
                   <div class="bottom-line" style="border-bottom: 1px solid #e7e7e7; margin: 5px 0 15px"></div>
                  </div>

                  <div v-for="(item, item_index) in reco_data.report" :key="item_index">
                   <div
                    v-for="(attachment, attachment_index) in item.files"
                    :key="attachment_index"
                    :style="[
                     attachment_index < item.files.length
                      ? {
                         borderBottom: '1px solid #ddd',
                         paddingBottom: '5px',
                         marginBottom: '15px',
                        }
                      : {},
                    ]"
                   >
                    <div class="flex-space-between bottom-margin-5">
                     <div class="input-label-xs-bold-black" style="font-size: 0.7rem">
                      Attachment
                      {{ attachment_index + 1 }}
                     </div>

                     <div class="font-08rem primary-theme-color cursor-pointer" @click="downloadAttachment(attachment)">
                      <i class="el-icon-download"></i>
                      Download
                     </div>
                    </div>
                   </div>
                  </div>

                  <div>
                   <div class="input-label-xs-bold-black">Discovery Logic</div>
                   <div class="input-label-gray font-08rem" style="max-height: 150px; overflow-y: auto; margin: 5px 0 10px" v-if="reco_data.logic_description">
                    {{ reco_data.logic_description }}
                   </div>
                   <div class="flex flex-wrap top-margin-15">
                    <div class="font-08rem" style="margin-right: 10px; margin-bottom: 15px" v-for="(subTags, tag_index) in reco_data.logic_tags" :key="tag_index">
                     <span class="sub-tags">
                      {{ subTags }}
                     </span>
                    </div>
                   </div>
                  </div>
                 </div>
                </el-popover>
               </span>
              </div>
             </div>
            </el-col>
           </el-row>
          </div>
          <div class="remaining-potential top-margin-15">
           <label class="input-label-bold-gray">Remaining Target</label>
           <div class="label-md-bold-black top-margin-5">
            <span class="remaining-potential-btns">
             <span style="margin-left: 5px">
              <span v-if="reco_data.reco_status == 'YET TO LIVE'">{{ reco_data.max_profit_in_percentage }}%</span>
              <span v-else-if="reco_data.reco_status == 'TARGET ACHIEVED'">0%</span>
              <span v-else>{{ !reco_data.potential_as_of_current_date ? 0 : reco_data.potential_as_of_current_date }}%</span>
             </span>
            </span>
           </div>
          </div>
         </div>
         <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="small-box">
          <!-- stock details section -->

          <div class="reco-date-desktop text-right">
           <label class="input-label-gray" style="font-size: 11px">
            Reco Date :
            {{ reco_data.created_at | stock_live_price_date_filter }}
            <span v-if="$router.currentRoute.path != '/past-recommendations'" style="position: relative; top: 5px"></span>
           </label>

           <div class="flex-end">
            <span class="font-08rem right-margin-5 font-weight-600 input-label-gray">{{ reco_data.duration == 'Long_term' ? 'Long Term' : reco_data.duration }}</span>

            <span
             class="secondary-theme-color text-right font-09rem cursor-pointer"
             style="margin-right: 5px"
             v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'YET TO LIVE') && $router.currentRoute.path == '/past-recommendations'"
             @click="
              openUpdateRecoDialog({
               reco_data: reco_data,
               index: index,
              })
             "
            >
             <i class="el-icon-edit"></i>
            </span>

            <span class="download-btn right-margin-5" style="text-align: right" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED') && $router.currentRoute.path == '/past-recommendations'" @click="exitReco(reco_data, index)">EXIT</span>
           </div>

           <div
            v-if="reco_data.risk_tag && reco_data.risk_tag.length"
            class="tags"
            :style="[
             reco_data.risk_tag == 'low_risk'
              ? { backgroundColor: '#ECFFF3', color: '#0BA042' } // text color for low_risk
              : reco_data.risk_tag == 'moderate_risk'
              ? { backgroundColor: '#FFF6E6', color: '#EDB21A' } // text color for moderate_risk
              : reco_data.risk_tag == 'high_risk'
              ? { backgroundColor: '#FFF1F1', color: '#EA2526' } // Text color for high_risk
              : { backgroundColor: '#FFF6E6', color: '#EDB21A' }, // Default text color for moderate_risk
             { textTransform: 'capitalize' }, // Capitalize the text
            ]"
           >
            {{ reco_data.risk_tag.replace(/_/g, ' ') }}
           </div>
          </div>
         </el-col>
        </div>

        <div class="faded-border-bottom">&nbsp;</div>

        <div class="third-sec">
         <el-row class="reco-details-section">
          <el-col :xs="15" :sm="15" :md="12" :lg="12" :xl="12">
           <div class="flex-space-between profile-antestimateSection bottom-margin-10 flex-wrap">
            <div class="flex" style="align-items: unset">
             <img v-if="!reco_data.user.pic || reco_data.filtered_by == 'company'" src="../assets/images/navBar/avatar.jpg" class="user-profile-pic" alt />

             <img v-else :src="serverHostName + reco_data.user.pic" class="user-profile-pic" alt />

             <!-- if current route is not expert sections route then applied cursor pointer style to expert's name -->
             <div class="company-employee-details">
              <div class="flex">
               <div class="label-lg-black-bold right-margin-3" :style="[$router.currentRoute.path == '/experts-past-recommendations' ? { cursor: 'pointer' } : { cursor: 'text' }]" style="text-transform: capitalize; font-size: 14px">
                <!-- if filtered by company id then displyaed company name other wise user name -->
                <span v-if="reco_data.filtered_by == 'company'">{{ reco_data.user.company.name }}</span>
                <span v-else>{{ reco_data.user.full_name }}</span>
                <el-tooltip v-if="reco_data.user.mark_as_verified_user" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
                 <img class="info-Logo cursor-pointer" src="../assets/images/verify.svg" style="width: 16px" alt />
                </el-tooltip>
               </div>
              </div>

              <!-- if recos filtered by company id then displyaed their campany name followed by profession -->
              <span v-if="reco_data.filtered_by == 'company'">
               <span class="right-margin-3 input-label-gray">{{ reco_data.user.full_name }} -</span>
               <span class="right-margin-3 input-label-gray">{{ reco_data.user.profession }}</span>
              </span>

              <span v-if="reco_data.filtered_by != 'company'" class="input-label-gray" style="font-size: 11px">
               <span class="right-margin-3" v-if="reco_data.user.company && reco_data.user.profession != 'Student'">{{ reco_data.user.company.name }} -</span>

               <span class="right-margin-3" v-if="reco_data.user.profession == 'Student' && reco_data.user.institute_name">{{ reco_data.user.institute_name }} -</span>

               <span class="right-margin-3">{{ reco_data.user.profession }}</span>
              </span>

              <img v-if="reco_data.source == 'marketplace'" src="../assets/images/loudspeaker1.svg" width="17" height="17" title="Public recommendation" style="vertical-align: middle; margin-left: 5px" />

              <br />
             </div>
            </div>
           </div>
          </el-col>

          <el-col :xs="9" :sm="9" :md="12" :lg="12" :xl="12" class="performance-circle">
           <el-row class="performance-accuracy-container">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
             <div class="performance-section performance-section-two">
              <el-tooltip class="item" effect="dark" :disabled="reco_data.reco_status == 'YET TO LIVE'" :content="reco_data.reco_status == 'TARGET ACHIEVED' ? 100 + '%' : reco_data.performance + '%'" placement="top">
               <NewCircleProgress :transitionDuration="5000" :radius="35" :strokeWidth="8" :strokeColor="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0 ? '#079e3e' : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? '#d60918' : '#079e3e'" :value="getPerformanceWheelValue(reco_data) > 100 ? 100 : getPerformanceWheelValue(reco_data)">
                <div class style="font-size: 0.6rem; color: #000; font-weight: 600; width: 70px">
                 {{ reco_data.reco_status }}
                </div>
                <template v-slot:footer></template>
               </NewCircleProgress>
              </el-tooltip>

              <div class="progress-description">
               <div class="input-label-gray">
                <!-- if reco status is closed then displayed closed date to stop date calculation -->
                <span v-if="reco_data.reco_status == 'CLOSED'">
                 As on
                 {{ reco_data.closed_date_time | formatDate }}
                </span>

                <!-- if reco status is target achieved then displayed achieved date to stop date calculation -->
                <span v-if="reco_data.reco_status == 'TARGET ACHIEVED'">
                 As on
                 {{ reco_data.target_achieved_date_time | formatDate }}
                </span>

                <!-- if reco status is target not achieved then displayed result_date_time to stop date calculation -->
                <span v-if="reco_data.reco_status == 'TARGET NOT ACHIEVED'">
                 As on
                 {{ reco_data.target_not_achieved_date_time | formatDate }}
                </span>

                <span v-if="reco_data.reco_status == 'STOP LOSS TRIGGERED'">
                 As on
                 {{ reco_data.stop_loss_triggered_date_time | formatDate }}
                </span>

                <!--if only reco status is live, yet to live and updated -->
                <span v-if="reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'UPDATED'">As on {{ reco_data.stock.today | formatDate }}</span>

                <!-- reco duration section -->
                <!-- if reco status is live, yet to live, stop loss triggered and current date is reco date then displayed -->
                <div class="" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED') && reco_data.difference_in_days == 0">(Today)</div>

                <!-- if only reco status is live, yet to live, stop loss triggered, target achieved, target not achieved and current date is greater than reco date -->
                <div class="" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days != 0">
                 ({{ reco_data.difference_in_days }}
                 <span v-if="reco_data.difference_in_days > 1">Days</span>
                 <span v-else>Day</span>
                 from reco date)
                </div>

                <!-- if reco status is updated and current date is reco date then displayed -->
                <div class="" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days == 0">(Updated Today)</div>

                <!-- if reco status is updated and current date is greater than reco date -->
                <div class="" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days != 0">
                 ({{ reco_data.difference_in_days }}
                 <span v-if="reco_data.difference_in_days > 1">Days</span>
                 <span v-else>Day</span>
                 from updated reco date)
                </div>

                <!-- if reco status is target achieved, target not achieved on same day (reco published day) then displayed -->
                <div class="" v-if="(reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days == 0">(On Reco date)</div>

                <!-- if recos closed or target achieved on updated reco day then displayed -->
                <div class="" v-if="reco_data.has_close_reco && reco_data.difference_in_days == 0 && reco_data.reco_status == 'TARGET ACHIEVED'">(On Updated Reco date)</div>
               </div>
              </div>
             </div>
            </el-col>
           </el-row>
          </el-col>
         </el-row>
        </div>

        <div class="flex top-margin-10" style="justify-content: space-between">
         <el-button class="cursor-pointer period-type-tag" style="width: 47%" :class="[reco_data.reco == 'Buy' ? 'active-period-type-tag' : reco_data.reco == 'Sell' ? 'active-period-type-tag-red' : reco_data.reco == 'Hold' ? 'active-period-type-tag-yellow' : 'period-type-tag']" v-on:click="goToTradePage(reco_data)">
          <img style="width: 16px; margin-right: 3px; position: relative; top: 3px" src="../assets/images/two-arrows.png" alt="" />
          {{ reco_data.reco }}
         </el-button>
        </div>
       </div>
       <div class="disclaimer-card" style="float: right">
        <div class="input-label-bold-gray">
         <el-popover placement="bottom" title="Disclaimer" width="200" trigger="click" content="Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.">
          <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg" style="height: 12px; top: 1px" alt slot="reference" />
         </el-popover>
         Disclaimer
        </div>
       </div>
       <div class="flex flex-center">
        <span class="input-label-gray cursor-pointer" style="color: red; margin: 3px 0 0; text-transform: capitalize" icon @click="toggleMoreInfo(index, reco_data)" v-if="reco_data.toggle_more_info">
         Less details
         <i class="el-icon-arrow-up"></i>
        </span>

        <span class="input-label-gray cursor-pointer" style="color: red; margin: 5px 0 0; text-transform: capitalize" icon @click="toggleMoreInfo(index, reco_data)" v-else>
         {{ reco_data.user.first_name ? reco_data.user.first_name + "'s" : reco_data.user.full_name ? reco_data.user.full_name.split(' ')[0] + "'s" : '' }}
         reco details
         <i class="el-icon-arrow-down"></i>
        </span>
       </div>

       <!-- <div class="faded-border-bottom">&nbsp;</div> -->

       <div v-if="reco_data.toggle_more_info">
        <StockProgress :stockData="reco_data" :selectedIndex="index" :segment="'Equity'"></StockProgress>
       </div>
      </div>

      <PremiumLock v-if="index != 0"></PremiumLock>
     </div>
    </el-card>
   </el-col>
  </el-row>
  <div class="sentiment-card-dialog tabs-dialog">
   <el-dialog :visible.sync="showSentimentCard" :before-close="clearTechnicalDataWidget">
    <div style="padding: 20px">
     <el-tabs v-model="activeTab">
      <el-tab-pane label="Market Sentiment" name="Market Sentiment">
       <div class="tab-market-sentiment">
        <MarketSentimentCard v-if="selectedSymbol" :stock_code="selectedSymbol" :key="selectedSymbol" style="border: 1px solid #dbdbdb; border-radius: 8px"></MarketSentimentCard>
       </div>
      </el-tab-pane>
      <el-tab-pane label="Fundamental Data" name="Fundamental Data">
       <iframe :src="'https://stocks.tickertape.in/' + selectedSymbol + '?broker=stockants'" width="100%" height="350px"></iframe>
      </el-tab-pane>
      <el-tab-pane label="Technical Data" name="Technical Data">
       <VueTradingView
        class="top-margin-15"
        v-if="selectedSymbol"
        :options="{
         symbol: 'BSE:' + selectedSymbol,
         theme: 'light',
         autosize: false,
         allow_symbol_change: true,
         autosize: true,
         locale: 'in',
         style: 3,
         interval: '1D',
        }"
        style="height: 350px"
       />
       <div class="tradingview-widget-copyright top-margin-10" v-if="selectedSymbol">
        <a href="https://in.tradingview.com/" rel="noopener nofollow" target="_blank">
         <span class="blue-text">{{ selectedSymbol }} stock chart by TradingView</span>
        </a>
       </div>
      </el-tab-pane>
     </el-tabs>
    </div>
   </el-dialog>
  </div>

  <div class="sentiment-card-dialog stock-profile-dialog">
   <el-dialog :visible.sync="isStockProfilePopupVisible" :show-close="false" :before-close="clearTradingViewWidget">
    <!-- TradingView Widget Container -->
    <div class="tradingview-widget-container" ref="tradingviewContainer">
     <div class="tradingview-widget-container__widget"></div>
    </div>
   </el-dialog>
  </div>
 </div>
</template>

<script>
import { serverAddr, serverHostName } from '../networkConfig';
import NewCircleProgress from './NewCircularProgress';
import { filterCallBack } from '../mixins/filter';
import { EventBus } from '../eventBus';
import Timer from './Timer';
import { filter } from 'minimatch';
import ComparedRecommendationsOfExpert from './ComparedRecommendationsOfExpert';
import { some } from 'lodash';
import { HelperNetworkCallBack } from '../mixins/Helper';
import { screenSize } from '../mixins/ScreenSize.js';
import CripNotice from 'crip-vue-notice';
import PremiumLock from './LockForPremiumPlan.vue';
import StockProgress from './StockProgressBarComponent.vue';
import MarketSentimentCard from '@/components/MarketSentimentCard.vue';
import VueTradingView from 'vue-trading-view/src/vue-trading-view';

export default {
 name: 'RecommendationDetailsCard',
 props: ['recommendationsList', 'recoType'],

 mixins: [filterCallBack, HelperNetworkCallBack, screenSize],

 components: {
  NewCircleProgress,
  Timer,
  ComparedRecommendationsOfExpert,
  PremiumLock,
  StockProgress,
  MarketSentimentCard,
  VueTradingView,
 },

 data() {
  return {
   serverHostName: serverHostName,
   websiteUserType: {},
   currentEnvironment: {},
   selectedSymbol: '',
   activeTab: 'Market Sentiment',
   showSentimentCard: false,
   userProfile: {},
   currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,

   isStockProfilePopupVisible: false,
  };
 },

 watch: {
  // recommendationsList: function(old, newVal) {
  //   newVal.forEach(e => {
  //     if (e.reco_struct === undefined) {
  //       e.reco_struct = this.recoType === 'shortTerm' ? 'short_term' : 'long_term';
  //     }
  // })
  // }
 },

 mounted() {
  this.userProfile = JSON.parse(localStorage.getItem('profile')) ? JSON.parse(localStorage.getItem('profile')) : {};

  // select user type for navigation access
  if (localStorage.getItem('websiteUserType')) {
   this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));
  }

  EventBus.$on('removedComparedExpertFromList', (index) => {
   this.recommendationsList[index].expert = '';
  });

  if (localStorage.getItem('currentEnvironment')) {
   this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
  }
 },

 methods: {
  loadTradingViewWidget(symbol) {
   this.isStockProfilePopupVisible = true;

   this.$nextTick(() => {
    this.loadTradingViewWidgetContent(symbol);
   });
  },

  loadTradingViewWidgetContent(symbol) {
   const container = this.$refs.tradingviewContainer;
   if (!container) {
    console.error('TradingView container not found');
    return;
   }

   // Clear previous content
   container.innerHTML = '';

   // Create required DOM structure
   const widgetDiv = document.createElement('div');
   widgetDiv.className = 'tradingview-widget-container__widget';

   const copyright = document.createElement('div');
   copyright.className = 'tradingview-widget-copyright';
   copyright.innerHTML = `<a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
      <span class="blue-text">Track all markets on TradingView</span></a>`;

   const script = document.createElement('script');
   script.type = 'text/javascript';
   script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-symbol-profile.js';
   script.async = true;

   // This is the magic part — JSON as text inside script tag
   script.text = JSON.stringify({
    width: '100%',
    height: '450',
    isTransparent: false,
    colorTheme: 'light',
    symbol: `BSE:${symbol}`,
    locale: 'en',
   });

   // Append elements in correct order
   container.appendChild(widgetDiv);
   container.appendChild(copyright);
   container.appendChild(script);
  },

  clearTradingViewWidget(done) {
   const container = this.$refs.tradingviewContainer;
   if (container) {
    container.innerHTML = '';
   }
   done();
  },

  clearTechnicalDataWidget() {
   this.selectedSymbol = ''; // Clear previous symbol
   this.$nextTick(() => {
    this.selectedSymbol = ''; // for fully cleared
   });

   this.showSentimentCard = false;
   this.activeTab = 'Market Sentiment';
  },
  // goToTradePage() {
  //   if (this.websiteUserType.userType != 'broker') {
  //     this.$store.commit('commitBrokerLoginDialogVisibility', true);
  //   } else {
  //     this.$store.commit('commitSubscribPlanDialogVisibility', true);
  //   }
  // },

  goToTradePage(stockDetails) {
   var stockData = {};
   stockData.segment = 'equity';
   stockData.symbol = stockDetails.stock.symbol;
   stockData.stock_id = stockDetails.stock.id;
   stockData.stop_loss = stockDetails.stop_loss;
   stockData.target_price = stockDetails.target_price;
   stockData.order_type = stockDetails.reco;
   stockData.entry_price = stockDetails.reco_open_price;
   stockData.ltp = stockDetails.stock.current_price;
   stockData.duration = stockDetails.duration;

   if (this.isTradeVisible()) {
    if (stockDetails.reco == 'Buy') {
     // set parameters for pre selected stock in trade button
     this.$store.commit('commitTradeMenu', 'TRADE');
     this.$store.commit('commitSelectedOrder', stockData);
     this.$store.commit('tradePopupAction', true);
     this.isDataChanged = true;
    } else if (stockDetails.reco == 'Sell') {
     this.isVisibleSellNotAllowedPopup = true;
    }
   } else {
    if (this.websiteUserType.userType != 'broker') {
     this.$store.commit('commitBrokerLoginDialogVisibility', true);
     this.$store.commit('commitSelectedOrder', stockData);
    } else {
     this.$store.commit('commitSubscribPlanDialogVisibility', true);
    }
   }
  },

  openPopupForMoreDetails(data) {
   this.selectedSymbol = data.stock.symbol;
   this.activeTab = 'Market Sentiment';
   this.showSentimentCard = true;
  },

  goToPlanPage() {
   // closed dialog before going on pricing page
   setTimeout(() => {
    localStorage.setItem('premiumPlanSubscriptionDialogVisible', true);
   }, 1500);

   this.$router.push({ path: '/pricing' });
  },

  downloadAttachment(attachment_link) {
   if (attachment_link) {
    window.open(`${serverHostName}${attachment_link}`, '_blank');
   }
  },

  openStockWidgetDialog(stock_code) {
   this.$emit('openStockWidget', stock_code);
  },

  calculateRemainingPotential(reco_data) {
   var target_price = reco_data.target_price;
   var remaining_potential_for_one = 0;
   var one_lack_rp = 0;
   var current_price = reco_data.reco_status == 'TARGET ACHIEVED' ? target_price : reco_data.reco_status == 'YET TO LIVE' ? reco_data.reco_open_price : reco_data.reco_status == 'STOP LOSS TRIGGERED' ? reco_data.stop_loss : reco_data.reco_status == 'EXIT' ? reco_data.exit_price : reco_data.reco_status == 'TARGET NOT ACHIEVED' ? reco_data.target_not_achieved_price : reco_data.stock.current_price;

   if (reco_data.reco == 'Buy') {
    remaining_potential_for_one = target_price - current_price;
   } else if (reco_data.reco == 'Sell') {
    remaining_potential_for_one = current_price - target_price;
   }

   remaining_potential_for_one = remaining_potential_for_one < 0 ? 0 : remaining_potential_for_one;

   one_lack_rp = (100000 / current_price) * remaining_potential_for_one;

   return this.isFloat(one_lack_rp);
  },

  getPerformanceWheelValue(reco_data) {
   if (reco_data.performance == null || reco_data.performance == '') {
    return String(0);
   } else if (reco_data.reco_status == 'TARGET ACHIEVED') {
    return String(100);
   } else if (reco_data.performance < 0) {
    return String(reco_data.performance);
   }

   let v = String(((reco_data.performance / reco_data.target_potential) * 100).toFixed(2));
   if (v > 100) {
    return 100;
   }

   return v;
  },

  // goToResultPage(reco) {
  //   // checked subscribed plan has access to this filter
  //   //restricted filters to access for expert section if trial plan is subscribed
  //   //same component is being used on user and expert section
  //   if (
  //     (!Object.keys(this.subscribedPlanDetails).length ||
  //       this.subscribedPlanDetails.plan == "Lite") &&
  //     this.$router.currentRoute.path == "/experts-past-recommendations"
  //   ) {
  //     this.$store.commit("commitSubscribPlanDialogVisibility", true);
  //     return;
  //   }

  //   if (
  //     this.$router.currentRoute.path == "/past-recommendations" ||
  //     this.$router.currentRoute.path == "/long-term-reco-data-track" ||
  //     this.$router.currentRoute.path == "/user-short-term-performance" ||
  //     this.$router.currentRoute.path == "/user-long-term-performance"
  //   ) {
  //     if (this.recoType == "shortTerm") {
  //       let routeData = this.$router.resolve({
  //         name: "shortTermresult",
  //         query: {
  //           stockId: reco.stock.Id,
  //           resultDate: reco.result_date_time,
  //           duration: reco.duration,
  //         },
  //       });
  //       window.open(routeData.href, "_blank");
  //     } else {
  //       let routeData = this.$router.resolve({
  //         name: "longTermresult",
  //         query: {
  //           stockId: reco.stock.Id,
  //           resultDate: reco.result_date_time,
  //         },
  //       });
  //       window.open(routeData.href, "_blank");
  //     }
  //   } else {
  //     if (this.recoType == "shortTerm") {
  //       //  if recos are filtered by company id then sent company id other wise user id
  //       let routeData = this.$router.resolve({
  //         name: "otherExpertShortTermAccuracyGraph",
  //         params: {
  //           stockId: reco.stock.Id,
  //           expertId:
  //             reco.filtered_by == "company"
  //               ? reco.user.company_id
  //               : reco.user.user_profile_id,
  //           createdDate: reco.created_at,
  //           resultDate: reco.result_date_time,
  //           duration: reco.duration,
  //           filtered_by: reco.filtered_by,
  //         },
  //       });
  //       window.open(routeData.href, "_blank");
  //     } else {
  //       let routeData = this.$router.resolve({
  //         name: "otherExpertLongTermAccuracyGraph",
  //         params: {
  //           stockId: reco.stock.Id,
  //           expertId:
  //             reco.filtered_by == "company"
  //               ? reco.user.company_id
  //               : reco.user.user_profile_id,
  //           createdDate: reco.created_at,
  //           resultDate: reco.result_date_time,
  //           duration: reco.duration,
  //           filtered_by: reco.filtered_by,
  //         },
  //       });
  //       window.open(routeData.href, "_blank");
  //     }
  //   }
  // },

  openUpdateRecoDialog(reco) {
   this.$emit('openUpdateRecoDialog', reco);
  },

  //remove reco from list
  removeFromList(index) {
   this.recommendationsList.splice(index, 1);
  },

  //toogle more information
  toggleMoreInfo(index) {
   this.recommendationsList[index].toggle_more_info = !this.recommendationsList[index].toggle_more_info;

   if (this.recommendationsList[index].toggle_more_info && !this.recommendationsList[index].closed_reco_list.length && this.recommendationsList[index].has_close_reco) {
    this.getAllClosedRecoListByRecoId(index);
   }
  },

  //api called to get short term data track list
  getAllClosedRecoListByRecoId(index) {
   this.recommendationsList[index].closed_reco_list_loading = true; //enabled loader

   serverAddr
    .post('recommendation/v1/read_recommendation', {
     id: this.recommendationsList[index].id,
     close_reco: true,
    })
    .then((response) => {
     if (response.data.status) {
      this.recommendationsList[index].closed_reco_list = response.data.data;
     } else {
      this.recommendationsList[index].closed_reco_list = [];
     }

     this.recommendationsList[index].closed_reco_list_loading = false; //disabled loader
    })
    .catch((error) => {
     console.log(error);
     this.recommendationsList[index].closed_reco_list_loading = false; //disabled loader
    });
  },

  //api called to get market expert list to compare reco with market expert
  getMarketExpertList(reco_id, index) {
   serverAddr
    .get(`/recommendation/v1/compare_reco_with_other_expert/${reco_id}`)
    .then((response) => {
     if (response.data.status) {
      this.recommendationsList[index].expert_list = response.data.data;
     } else {
      this.recommendationsList[index].expert_list = [];
     }
    })
    .catch(function (error) {
     console.log(error);
    });
  },

  //select expert from expert dropdown list : checked if expert is already added in the list
  selectExpert(expertIndex, expertData, index) {
   if (
    !some(this.recommendationsList[index].compared_experts_list, {
     id: expertData[expertIndex].id,
    })
   ) {
    this.$set(expertData[expertIndex], 'toggle_more_info', false); // created new key toggle_more_info in response for toggle content section
    //calculate difference between today & created date
    expertData[expertIndex].difference_in_days = this.getDifferenceBetweenTwoDays(expertData[expertIndex].last_close_reco ? expertData[expertIndex].last_close_reco : expertData[expertIndex].created_at, expertData[expertIndex].closed_date_time != null ? expertData[expertIndex].closed_date_time : expertData[expertIndex].stock.today);

    this.recommendationsList[index].compared_experts_list.push(expertData[expertIndex]);
   }
  },

  //go to antestimate link
  goToAntestimateLink(item) {
   // checked subscribed plan has access to this filter
   //restricted filters to access for expert section if trial plan is subscribed
   //same component is being used on user and expert section
   if ((!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') && this.$router.currentRoute.path == '/experts-past-recommendations') {
    this.$store.commit('commitSubscribPlanDialogVisibility', true);
    return;
   }

   // passed stock_id and user_id
   if (item.filtered_by == 'company') {
    let routeData = this.$router.resolve({
     name: 'unlockedAntEstimate',
     params: {
      reco_id: item.id,
      user_id: item.user.user_profile_id,
      stock_id: item.stock.Id,
      duration: item.duration,
      user_type: item.filtered_by,
      company_id: item.user.company_id,
     },
    });
    window.open(routeData.href, '_blank');
   } else {
    let routeData = this.$router.resolve({
     name: 'unlockedAntEstimate',
     params: {
      reco_id: item.id,
      user_id: item.user.user_profile_id,
      stock_id: item.stock.Id,
      duration: item.duration,
     },
    });
    window.open(routeData.href, '_blank');
   }
  },
 },

 computed: {
  //returns subscribed plan details from local storage
  subscribedPlanDetails() {
   return JSON.parse(localStorage.getItem('plan_details'));
  },
 },

 beforeDestroy() {
  EventBus.$off();
 },
};
</script>

<style lang="scss" scoped>
.RecommendationDetailsCard {
 .box-card {
  border-radius: 8px;
 }

 .tags {
  float: right;
  width: auto;
  align-items: center;
  margin-top: 10px;
  padding: 5px 10px 5px 10px;
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 500px;
  border-radius: 5px;
 }

 .period-type-tag {
  text-align: center;
  border-radius: 8px;
  padding: 8px 10px 10px;
  margin: 0 auto;
  color: #409eff;
  border: 1px solid;
  min-width: 50px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
 }

 .active-period-type-tag {
  border-color: #079e3e;
  background-color: #079e3e;
  color: #fff !important;
 }

 .active-period-type-tag-yellow {
  border-color: #e2ba00;
  background-color: #e2ba00;
  color: #fff !important;
 }

 .active-period-type-tag-red {
  border-color: #d60918;
  background-color: #d60918;
  color: #fff !important;
 }

 .download-btn {
  font-size: 8px;
  padding: 1px 5px 2px;
 }

 .more-btn {
  font-size: 9px;
  color: #2488fe;
  font-weight: 600;
 }

 .remaining-potential-desktop {
  display: flex;
  justify-content: center;
 }

 .roi-card-main {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .roi-card {
   font-size: 0.7rem;
   padding: 0px 5px;
   margin: 0 7px;
   text-align: left;

   p {
    margin: 5px;
   }

   .input-label-bold-gray {
    margin-bottom: 10px;
   }
  }
 }

 .remaining-potential-btns {
  background: #e9f9eff7;
  padding: 4px 5px;
  color: #079e3e;
  border-radius: 5px;
  margin-right: 3px;
 }

 .Mobile-card {
  display: none;
 }

 .reco-section {
  /* text-align: center; */
  display: flex;
  justify-content: left;
 }

 .box-card-two {
  .reco-date-mobile,
  .mobile-view {
   display: none;
  }

  .first-sec {
   display: flex;
   justify-content: space-between;
   flex-wrap: wrap;
  }

  .second-sec {
   margin-top: 15px;

   .stock-title {
    font-size: 18px;
   }

   .estimate-value {
    font-size: 16px !important;
   }
  }

  .third-sec {
   .input-label-gray {
    font-size: 10px;
   }

   .reco-details-section {
    display: flex; // align-items: center;
    align-items: flex-start;
   }

   .right-border {
    border-right: 1px solid #e9e9e9;
    margin-right: 20px;
   }

   .small-box {
    // height: 50px;
    // position: relative;
    // top: 20px;
   }
  }
 }

 .mobile-blocks {
  display: none;
 }

 .reco-type-potential-block {
  text-align: center;
  margin: 0 auto;

  .reco-type-box {
   margin-top: 10px;
   background-color: #ffff;
   box-shadow: 1px 1px 3px 1px #00000026;
   font-size: 12px;
   display: flex;
   justify-content: space-around;
   padding: 6px 2px;
   border-radius: 5px;
   color: #303133;
   width: 200px;
  }
 }

 .mobile-blocks {
  display: none;
 }

 .reco-type-potential-block {
  text-align: center;
  margin: 0 auto;

  .reco-type-box {
   margin-top: 10px;
   background-color: #ffff;
   box-shadow: 1px 1px 3px 1px #00000026;
   font-size: 12px;
   display: flex;
   justify-content: space-around;
   padding: 6px 2px;
   border-radius: 5px;
   color: #303133;
   width: 200px;
  }
 }

 .reco-btns {
  max-width: 50px;
  margin: 10px 0 !important;
  display: block;
 }

 .reco-btns-trade {
  display: flex !important;
  align-items: center;
  justify-content: center;
 }

 .reco-details {
  // padding-bottom: 20px;

  .antestimate-block {
   background: #2d2e8d;
   color: #ffff;
   border-radius: 5px;
   width: 88%;
   margin-bottom: 10px;
  }
 }

 .target-period-section {
  display: flex !important;
  justify-content: center;
  border-right: 1px solid #ddd;
 }

 .target-period-details {
  display: block;
 }

 .performance-section {
  display: flex;
  justify-content: space-around;
  padding: 0 10px;
  text-align: center;
  border-right: 1px solid #ddd;
 }

 .progress-description {
  // height: 40px;
  text-align: left;
  margind-top: 7px;
 }

 .progress-bar-legends {
  width: 12px;
  height: 12px;
  background-color: #a29eab;
  border-radius: 3px;
  margin: 0 10px 0 0;
 }

 .legends-text {
  font-size: 0.8rem;
  margin-right: 5px;
 }

 .accuracy-section {
  text-align: center;
  display: flex;
  flex-direction: column; // padding: 0!important;
 }

 .antestimate-block {
  text-align: center;
  border-radius: 20px;
  border: 1px solid #333;
  font-size: 0.8rem;
  font-weight: 500;
  color: #000;
  padding: 5px 10px;
  width: fit-content;
  margin: 5px auto;
 }

 .faded-border-bottom {
  display: block;
  border: none;
  color: #fff;
  height: 1px;
  background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 450, from(#f1f1f1), to(#fff));
 }

 .timer {
  align-self: center;
 }

 .cross-icon {
  color: #ddd;
  font-size: 20px;
 }

 .cross-icon:hover {
  font-size: 20px;
  color: black;
  cursor: pointer;
 }

 .border-bottom-gray {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
 }

 .user-profile-pic {
  height: 38px;
  width: 38px;
  border-radius: 50px;
  margin-right: 10px;
  object-fit: cover;
 }

 .bottom-margin-10 {
  margin-bottom: 8px;
 }

 .flex-column {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
 }

 .reco-more-details-container {
  display: flex;
  justify-content: space-around;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 18px;
 }

 .active-period-type-tag:focus,
 .period-type-tag:focus {
  outline: none;
 }

 .vertical-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
 }

 .info-Logo {
  width: 22px;
  height: 22px;
  padding: 0px 2px 0px 3px;
  position: relative;
  top: 4px;
 }

 .expertPerformanceListSection {
  border-top: 1px dashed #ddd;
  padding: 5px 0 0;
  margin-top: 10px;
 }

 .progress-bar-legends-section {
  display: flex;
  justify-content: center;
  text-align: center;
 }

 //media queries
 @media screen and (max-width: 1284px) {
  .performance-section-two {
   display: block;
   text-align: center;
   border-right: none;

   .progress-description {
    text-align: center;
    padding: 0;
    margin-top: 0;
   }
  }
 }

 @media screen and (max-width: 1200px) {
  .reco-section {
   display: block;
   margin: 10px 0 0 0;
  }

  .reco-btn-section {
   display: flex;
  }

  .reco-btn-section .reco-btns {
   margin: 0 10px 0 0 !important;
  }

  .target-period-section {
   margin: 20px 0 0 0;
   display: flex !important;
   justify-content: space-between;
   border-right: none;
  }

  .target-period-details {
   display: flex;
   justify-content: center;
   width: 100%;
   /* border-bottom: 1px solid #ddd; */
   padding-bottom: 10px;
   flex-wrap: wrap;
  }

  .period-contents {
   padding: 0 20px 0 0;
  }
 }

 @media screen and (min-width: 993px) {
  .isMobileView {
   display: none;
  }

  .target-period-section-border {
   display: none;
  }
 }

 @media screen and (max-width: 992px) {
  // .box-card-two .third-sec .small-box {
  //   top: 40px;
  // }

  .isDeskTopView {
   display: none;
  }

  .isMobileView {
   // margin-top: 30px;
  }

  .performance-accuracy-container {
   margin-top: 20px;
  }

  .mobile-blocks {
   display: block;
  }

  .target-period-box {
   background-color: #f6f6f6;
   padding: 8px 12px;
   border-radius: 5px;
   box-shadow: 1px 1px 3px 1px #00000026; // width: 120px;
   margin: 7px;
  }

  .desktop-blocks {
   display: none;
  }
 }

 @media screen and (max-width: 680px) {
  .box-card-two {
   .reco-date-mobile img {
    width: 15px !important;
    margin: 0;
   }

   .inner-card {
    // line-height: 0.7rem;
   }

   .label-xs-bold {
    font-size: 10px;
   }

   .performance-accuracy-container {
    margin-top: 0px;
   }

   .input-label-gray {
    font-size: 11px;
   }

   .mobile-view {
    display: block;
   }

   .desktop-view {
    display: none;
   }

   .third-sec {
    // .reco-details-section {
    //   display: unset;
    // }
    .performance-circle {
     // width: 100%;
    }

    .input-label-bold-gray {
     font-size: 10px;
    }

    .input-label-gray {
     font-size: 10px !important;
    }

    .label-md-bold-black {
     font-size: 12px !important;
    }

    // .small-box {
    //   top: 10px;
    // }
   }

   .second-sec {
    margin-top: 10px;

    .stock-title {
     font-size: 16px;
    }

    .code-title {
     font-size: 0.6rem;
    }

    .estimate-value {
     font-size: 14px !important;
    }
   }
  }
 }

 @media screen and (max-width: 575px) {
  .info-Logo {
   width: 18px;
   height: 18px;
  }

  .target-period-details {
   justify-content: center;
  }

  .reco-type-potential-block .reco-type-box {
   width: 170px;
  }

  .period-contents {
   padding: 0 0px 0 0;
  }

  .performance-section {
   padding: 0 5px;
  }

  .progress-bar-legends-section {
   display: block;
  }

  .accuracy-section {
   padding: 0 5px !important;
  }

  .faded-border-bottom {
   display: block;
   border: none;
   color: #fff;
   height: 1px;
   background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 250, from(#ddd), to(#fff));
  }
 }

 @media screen and (max-width: 550px) {
  .box-card-two {
   .reco-date-desktop {
    display: none;
   }

   .reco-date-mobile {
    display: block;
   }

   .third-sec {
    // margin: 10px 0;
    .right-border {
     margin-right: 10px;
    }

    // .small-box {
    //   height: 80px;
    // }
   }

   // .remaining-potential {
   //   margin-top: 10px;
   // }
  }

  .accuracy-section {
   margin-top: 30px;
  }

  .reco-type-potential-block .reco-type-box {
   font-size: 10px;
   width: 120px;
   padding-bottom: 0;
  }

  .profile-antestimateSection {
   flex-wrap: wrap;
  }

  .reco-details .antestimate-block {
   margin-top: 20px; // margin-left: 30px;
  }

  .reco-details .antestimate-mobile {
   margin-left: 30px;
  }

  .target-period-box {
   padding: 8px 7px;
   margin: 5px;

   .input-label-bold-gray {
    font-size: 11px;
   }

   .label-xs-bold {
    font-size: 12px;
   }
  }
 }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.RecommendationDetailsCard .sentiment-card-dialog {
 .tab-market-sentiment {
  .stock-details {
   margin: 15px;
  }

  .sentiment-options {
   display: none;
  }

  // .el-card__body,
  // .el-main {
  //   padding: 0;
  // }

  // .box-card {
  //   margin: 0;
  // }
 }

 .el-dialog {
  margin-top: 100px;
  width: 400px;
  border-radius: 8px;
 }

 .el-dialog__body,
 .el-dialog__header {
  padding: 0px;
 }

 .el-dialog__headerbtn .el-dialog__close {
  z-index: 2;
  position: relative;
 }

 .box-card {
  border-radius: 10px !important;
  border: none;
  box-shadow: none;
 }

 .box-card-two {
  margin: 5px;
 }

 .employee-select-box .el-input--mini .el-input__inner {
  height: 25px;
  border-radius: 8px;
  text-transform: capitalize;
 }

 .el-progress-bar {
  padding: 0;
 }

 .el-progress__text {
  display: none;
 }

 .vuejs-countdown .digit {
  font-size: 28px;
 }

 .el-checkbox__inner {
  border-radius: 4px;
 }
}

.RecommendationDetailsCard .tabs-dialog {
 .el-dialog {
  width: 700px;
 }
}

.el-select-dropdown__list li {
 font-size: 12px;
}

.el-select-dropdown__item:hover {
 color: $primary-theme-color !important;
 background-color: #f5f7fa !important;
}

.el-select-dropdown__item.selected {
 color: $primary-theme-color;
}

.el-popover {
 background-color: #fff !important;
 border: none !important;
}

@media screen and (max-width: 720px) {
 .RecommendationDetailsCard .tabs-dialog {
  .el-dialog {
   width: 95%;
  }
 }
}

@media screen and (max-width: 600px) {
 .RecommendationDetailsCard {
  .sentiment-card-dialog {
   .el-dialog {
    margin-top: 20px;
    width: 95%;
   }
  }
 }
}

@media screen and (max-width: 480px) {
 .RecommendationDetailsCard .box-card {
  .timer .day,
  .timer .hour,
  .timer .min,
  .timer .sec {
   font-size: 17px;
  }
 }

 .RecommendationDetailsCard .box-card {
  .el-card__body {
   padding: 12px;
  }
 }
}
</style>
